import dayjs from "dayjs";
export default function calculateCompetitionDays(start, end) {
    const startDay = dayjs(start);
    if (!end || startDay.isSame(end))
        return [startDay.format("YYYY-MM-DD")];
    const endDay = dayjs(end);
    const difference = endDay.diff(startDay, "days");
    const dates = [startDay.format("YYYY-MM-DD")];
    for (let i = 1; difference >= i; i++) {
        dates.push(startDay.add(i, "day").format("YYYY-MM-DD"));
    }
    return dates;
}
